<template>
	<div class="modal fade" id="signFilesModal" role="dialog" aria-labelledby="signFilesModalLabel" data-backdrop="static" aria-hidden="true">
		<div class="modal-dialog modal-xl" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" :class="isOverdue ? 'text-danger' : ''" id="signFilesModalLabel">{{$tc('signing.pageTitle',1)}}</h5>
                    <span v-if="isOverdue" class="badge badge-danger">{{ $t('signing.overdue') }}</span>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
                    <kendo-tabstrip>
                        <ul>
                            <li class="k-state-active">{{ $t('signing.details') }}</li>
                            <li>{{ $t('signing.history') }}</li>
                            <li>{{ $t('signing.result') }}</li>
                        </ul>
                        <div>
                            <div class="row">
                                <div class="col-lg-6 form-group">
                                    <label class="font-weight-bold">{{$t('signing.headers.title')}}</label>
                                    <div>{{model.title}}</div>
                                </div>
                                <div class="col-lg-6 form-group">
                                    <label class="font-weight-bold">{{$t('request_n')}}</label>
                                    <div>{{model.request}}</div>
                                </div>
                                <div class="col-lg-6 form-group">
                                        <label class="font-weight-bold">{{$t('signing.headers.creator')}}</label>
                                        <div>{{model.creatorName}}</div>
                                </div>
                                <div class="col-lg-6 form-group">
                                        <label class="font-weight-bold">{{$t('signing.headers.deadline')}}</label>
                                        <div>{{ model.deadline ? $moment(model.deadline).format('DD.MM.YYYY HH:mm') : '' }}</div>
                                </div>
                                <table class="table table-hover" v-if="model.attachments && model.attachments.length && !isSigning">
                                    <thead>
                                        <tr>
                                            <th>
                                                <vs-checkbox v-model="massCheck" />
                                            </th>
                                            <th>{{ $t('signing.filesGirdHeaders.fileName') }}</th>
                                            <th>{{ $t('signing.filesGirdHeaders.fileDescription') }}</th>
                                            <th>{{ $t('signing.filesGirdHeaders.isSigned') }}</th>
                                            <th>{{ $t('signing.filesGirdHeaders.timestampUtc') }}</th>
                                            <th>{{ $t('signing.filesGirdHeaders.signedBy') }}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in model.attachments" :key="index">
                                            <td>
                                                <span v-if="!isAlloweFileType(item.type)">Непозволен тип</span>
                                                <span v-else>
                                                    <vs-checkbox v-if="!item.isSigned" v-model="item.isChecked" />
                                                </span>
                                            </td>
                                            <td class="py-0 align-middle">{{ item.fileName }}</td>
                                            <td class="py-0 align-middle">{{ item.description }}</td>
                                            <td class="text-center py-0 align-middle"><span class="badge" :class="item.isSigned ? 'badge-success' : 'badge-light'">{{ item.isSigned ? $t("yes") : $t("no") }}</span></td>
                                            <td class="py-0 align-middle">{{ item.signingDate ? $moment(item.signingDate).format('DD.MM.YYYY HH:mm') : '' }}</td>
                                            <td class="py-0 align-middle">{{ item.signatoryName }}</td>
                                            <td class="text-center py-0">
                                                <file-crud :file="item"
                                                    :readonly="true"
                                                    :showDescription="false"
                                                    :type="item.docTypeCode"
                                                    hide-file-name>
                                                </file-crud>
                                            </td>
                                        </tr>
                                        <tr>
                                            <button
                                                v-if="model.attachments.some(x => x.isChecked === true)"
                                                type="button"
                                                class="btn btn-primary"
                                                @click="onSignClick">{{$t('signing.sign')}}
                                            </button>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div>
                            <div v-if="show">
                                <history :signingId="model.id"></history>
                            </div>
                        </div>
                        <div>
                            <div v-if="show">
                                <result :signingId="model.id"></result>
                            </div>
                        </div>
                    </kendo-tabstrip>
                    <progress-bar
                        v-if="isSigning"
                        v-model="progress"
                        min="0"
                        :max="progressMax"
                        :description="progressText"
                        class="my-2"
                    />
                    <div
                        class="accordion mt-2"
                        id="relatedItems"
                        v-if="model.relatedTaskId || model.relatedCoordinationId"
                    >
                        <div class="card" v-if="relatedTask">
                            <div class="card-header" id="headingOne">
                                <h2 class="mb-0">
                                    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                        {{ $t('signing.relatedTask') }}
                                    </button>
                                </h2>
                            </div>

                            <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#relatedItems">
                                <div class="card-body">
                                    <task-details-card :model="relatedTask" show />
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="relatedCoordination">
                            <div class="card-header" id="headingTwo">
                                <h2 class="mb-0">
                                    <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        {{ $t('signing.relatedCoordination') }}
                                    </button>
                                </h2>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#relatedItems">
                                <div class="card-body">
                                    <coordination-details-card :model="relatedCoordination" show />
                                </div>
                            </div>
                        </div>
                    </div>
				</div>
				<div class="modal-footer">
						<button type="button" class="btn btn-secondary" @click="onClose">{{$t('buttons.close')}}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import coordinationsService from '@/services/coordinations.service';
	import signingService from '@/services/signing.service'; // SigningController
	import signService from '@/services/sign.service';
	import tasksService from '@/services/tasks.service';
	import { Signing } from '@/models/models';
	import FileCrud from '../common/FileCRUD';
	import TaskDetailsCard from '@/components/tasks/details.card'
	import CoordinationDetailsCard from '@/components/coordinations/details.card'
    import ProgressBar from '@/components/common/ProgressBar.vue';
    import history from './history';
    import result from './result';
    import { SignaturePdfData } from '@/models/signaturePdfData.models';
    import { SignatureDocxData } from '@/models/signatureDocxData.models';
    import { MimeType, SigningStatus } from '@/models/enums';
    import { mapGetters } from 'vuex';

	export default {
		components: {
			FileCrud,
            history,
            result,
            TaskDetailsCard,
            CoordinationDetailsCard,
            ProgressBar
		},
		props: {
			value: {},
			show: {
				type: Boolean,
				required: false
			}
		},
		data() {
			return {
				model: new Signing(),
				isLoading: false,
				massCheck: false,
				isSigning: false,
				relatedTask: null, // Трябва да се взима от базата, ако има. Сложено за домонстрация
				relatedCoordination: null, // Трябва да се взима от базата, ако има. Сложено за домонстрация,
				progress: 0,
				progressMax: 0,
				progressText: '',
				selectedCertThumbprint: ''
			};
		},
        computed: {
            ...mapGetters(['appSigningSettings', 'userName', 'userEmail', 'userFullName', 'userFullNameEn', 'signingAllowFileTypes']),
            isOverdue() {
                if (!this.model || !this.model.deadline || this.model.statusId !== SigningStatus.started) {
                    return false;
                }

                const deadline = this.$moment(this.model.deadline);
                return deadline <= this.$moment();
            }
        },
		methods: {
			async onSignClick() {
                this.resetProgressBar();

                if (!this.model || !this.model.attachments) {
                    return this.$vs.notify({
                        title: this.$t('signing.signing'),
                        text: this.$t('signing.emptyModelError'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    });
                }

                const checkedAttachemntsToSign = this.model.attachments.filter(x => x.isChecked === true);
                if (!checkedAttachemntsToSign.length) {
                    return this.$vs.notify({
                        title: this.$t('signing.signing'),
                        text: this.$t('signing.missingSelectedAttachmentsToSign'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    });
                }

                if (!this.appSigningSettings) {
                    console.log('AppSigningSettings not loaded. Dispatch loadAppSigningSettingsAsync');
                    // Ако по някаква причина не са заредени конф.настройки за подписването се опитваме да ги заредим.
                    await this.$store.dispatch('loadAppSigningSettingsAsync');
                }

                const count = checkedAttachemntsToSign.length;
                this.progressMax = count + 1;

                this.isSigning = true;

                try {
                    const signatureBase64Image = (await this.downloadUserSignatureImage()).data;
                    for (const attachment of checkedAttachemntsToSign) {
                        this.progress += 1;
                        try {
                            await this.signAttachment(attachment, signatureBase64Image);
                        } catch (error) {
                            console.log(attachment, error);
                        }
                    }
                } catch (error) {
                    console.log(error);
                }

                await this.reloadAttachments();
                this.isSigning = false;
                this.resetProgressBar();
			},
			async signAttachment(attachment, signatureBase64Image) {
                this.progressText = `Сваляне на ${attachment.fileName}`;
                const attachmentBase64Content = (await signService.getBase64OfAFile(attachment)).data;

                this.progressText = `Подписване на ${attachment.fileName}`;

                let signResult;
                switch (attachment.type) {
                    case MimeType.Pdf:
                        signResult = await this.signPdf(attachmentBase64Content, signatureBase64Image);
                        break;
                    case MimeType.Docx:
                        signResult = await this.signDocx(attachmentBase64Content);
                        break;
                    default:
                        break;
                }

                // console.log(signResult);
                await this.saveSigningResult(attachment, signResult);
			},
            async signPdf(attachmentBase64Content, signatureBase64Image) {
                const payload = new SignaturePdfData({
                    contents: attachmentBase64Content,
                    thumbprint: this.selectedCertThumbprint
                });

                // payload.options.contact = this.userFullNameEn; // Contact Не се показва във визуалзацията на подписа
                // payload.options.reason = this.userFullNameEn; // Кирилица не се визуализира (ограничение в шрифтовете на iTextSharp)

                if (signatureBase64Image) {
                    payload.options.signatureImageBase64 = signatureBase64Image;
                }

                if (this.appSigningSettings && this.appSigningSettings.usersSettings) {
                    const userSigningSettings = this.appSigningSettings.usersSettings.find(x => x.username === this.userName);
                    console.log('userSigningSettings', userSigningSettings);

                    if (userSigningSettings && userSigningSettings.bookmarkId) {
                        payload.options.visualizatonType = "annotation";
                        payload.options.bookmarkName = userSigningSettings.bookmarkId;
                        payload.options.xStep = this.appSigningSettings.defaultPdfXStep;
                        payload.options.yStep = this.appSigningSettings.defaultPdfYStep;
                    }
                }

                return (await signService.signPdf(payload)).data;
            },
            async signDocx(attachmentBase64Content) {
                const payload = new SignatureDocxData({
                    contents: attachmentBase64Content,
                    thumbprint: this.selectedCertThumbprint,
                    options: {
                        name: this.userFullName,
                        email: this.userEmail
                    }
                });

                return (await signService.signDocx(payload)).data;
            },
            async saveSigningResult(attachment, signResult) {
                if (signResult && signResult.isError === false) {
                    // Ще поиска сертификат само първия път. В другите случаи подаваме thumbprint-а на избрания сертификат.
                    this.selectedCertThumbprint = signResult.thumbprint;
                    this.progressText = `Запазване на подписан ${attachment.fileName}`;
                    const saveResult = (await signingService.saveSignedAttachment({
                        signingId: this.model.id,
                        attachmentId: attachment.id,
                        fileName: attachment.fileName,
                        docTypeCode: attachment.docTypeCode,
                        signedBase64Content: signResult.contents
                    })).data;

                    if (saveResult && saveResult.isSigned === true) {
                        attachment.isSigned = saveResult.isSigned;
                        attachment.signatoryName = saveResult.signatoryName;
                        attachment.signingDate = saveResult.signingDate;
                    }

                    console.log(saveResult);
                } else {
                    throw Error(JSON.stringify(signResult));
                }
            },
            async downloadUserSignatureImage() {
                const downloadUri = this.$store.getters.baseUrl + `/api/user/SignatureImageBase64`;
                const response = await this.$http.get(downloadUri);
                return response;
            },
            resetProgressBar() {
                this.progressMax = 0;
                this.progress = 0;
                this.progressText = '';
                this.selectedCertThumbprint = '';
            },
			hide() {
				$(this.$el).modal('hide');
			},
			onClose() {
				this.$emit('update:show', false);
				this.$emit('onClose');
			},
			loadRelatedTask() {
                this.relatedTask = null;
                if (!this.model.relatedTaskId) return;

                tasksService
					.getDetailsById(this.model.relatedTaskId)
					.then((response) => {
						this.relatedTask = response.data;
					})
					.catch((error) => {
						this.$vs.notify({
							title: this.$t('notifications.error'),
							text: this.$helpers.errorText(error),
							color: this.$helpers.errorColor(error),
							time: this.$store.getters.notificationDuration,
						});
					});
            },
            loadRelatedCoorsination() {
                this.relatedCoordination = null;
                if (!this.model.relatedCoordinationId) return;

                coordinationsService
					.getDetailsById(this.model.relatedCoordinationId)
					.then((response) => {
                        this.relatedCoordination = response.data;
					})
					.catch((error) => {
						this.$vs.notify({
							title: this.$t('notifications.error'),
							text: this.$helpers.errorText(error),
							color: this.$helpers.errorColor(error),
							time: this.$store.getters.notificationDuration,
						});
					});
            },
            isSignedCellTemplate(isSigned) {
                return kendo.htmlEncode('<span class="badge ' + (isSigned ? "badge-success" : "badge-light") + '">' + (isSigned ? this.$t("yes") : this.$t("no")) + "</span>");
            },
            isAlloweFileType(type) {
                return !!type && this.signingAllowFileTypes.includes(type);
            },
            async reloadAttachments() {
                if (!this.model) return;

                this.clearAttachments();

                const attachments = (await signingService.getAttachments(this.model.id)).data;
                if (!this.model.attachments) this.model.attachments = [];

                attachments.forEach(el => {
                    this.model.attachments.push({ ...el, isChecked: false })
                });

                this.massCheck = true;
            },
            clearAttachments() {
                if (!this.model || !this.model.attachments) return;

                if (this.model.attachments && this.model.attachments.length > 0) {
                    while (this.model.attachments.length > 0) { this.model.attachments.pop(); }
                }

                this.massCheck = false;
            }
		},
		mounted() {
			// add modal close listener
			$(this.$el).on('hidden.bs.modal', this.onClose);
		},
		beforeDestroy() {
			// remove listener
			$(this.$el).off('hidden.bs.modal');
		},
		watch: {
			show: function (val) {
                this.relatedTask = null;
                this.relatedCoordination = null;

				if (val) {
					this.model = new Signing({ ...this.value });

                    signingService.getAttachments(this.model.id)
                    .then((result) => {
                        if (result.data && Array.isArray(result.data)) {
                            if (!this.model.attachments) this.model.attachments = [];

                            result.data.forEach(el => {
                                this.model.attachments.push({ ...el, isChecked: false })
                            });
                        }

                        this.massCheck = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    });

					this.loadRelatedTask();
                    this.loadRelatedCoorsination();

					$(this.$el).modal('show');
				} else {
					$(this.$el).modal('hide');
					this.massCheck = false;
				}
			},
			massCheck(val) {
                if (this.model.attachments && Array.isArray(this.model.attachments) && this.model.attachments.length > 0) {
                    for (const item of this.model.attachments.filter(x => !x.isSigned)) {
                        item.isChecked = val;
                    }
                }
			}
		}
	};
</script>

<style lang="scss" scoped>
.radio-message {
	padding: 3px 3px 3px 5px;
	border-left: 3px solid #03a9f4;
	box-shadow: 1px 1px 1px 1px lightgrey;
}

div.radio label {
	color: inherit;
	cursor: pointer;
}

.bmd-form-group {
	padding-top: 1rem !important;
}
</style>
